export default __webpack_public_path__ + "static/media/play-circle.67829b74.svg";